import { defineMessages } from 'react-intl';

export default defineMessages({
  department: {
    id: 'sentinel.components.createActionForm.department',
    defaultMessage: 'Department',
  },
  createAction: {
    id: 'sentinel.components.createActionForm.createAction',
    defaultMessage: 'Create Action',
  },
  description: {
    id: 'sentinel.components.createActionForm.description',
    defaultMessage: 'Description',
  },
});



// WEBPACK FOOTER //
// ./src/components/CreateActionForm/messages.js